import React, { } from "react";

import AllJourneys from "./journey/AllJourneys";

export function getDifferenceInDays(date) {
  const newDate = new Date();
  const oldDate = new Date(date);
  const diffTime = Math.abs(newDate - oldDate);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  // return diffDays;
  var msDiff = new Date(
    new Date().setHours(0, 0, 0, 0) - new Date(date).setHours(0, 0, 0, 0)
  );
  return Math.floor(msDiff / (1000 * 60 * 60 * 24));
}

const Journeys = () => {
  return <AllJourneys />;
};

export default Journeys;
